import script from "./ParsedMessage.vue?vue&type=script&lang=ts"
export * from "./ParsedMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"client/components/ParsedMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f0238fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f0238fa', __exports__)) {
    api.reload('3f0238fa', __exports__)
  }
  
}


export default __exports__